var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6464 0.146447C12.8417 -0.0488155 13.1583 -0.0488155 13.3536 0.146447L15.8536 2.64645C16.0488 2.84171 16.0488 3.15829 15.8536 3.35355L7.85355 11.3536C7.79347 11.4136 7.71906 11.4574 7.63736 11.4808L4.13736 12.4808C3.76018 12.5885 3.41147 12.2398 3.51924 11.8626L4.51924 8.36264C4.54258 8.28094 4.58636 8.20653 4.64645 8.14645L12.6464 0.146447ZM14.7929 3L13.5 4.29289L11.7071 2.5L13 1.20711L14.7929 3ZM12.7929 5L11 3.20711L5.44517 8.76194L4.72801 11.272L7.23806 10.5548L12.7929 5Z",
    fill: "#051C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5V9.5C13 9.22386 13.2239 9 13.5 9C13.7761 9 14 9.22386 14 9.5V14.5C14 15.3281 13.3281 16 12.5 16H1.5C0.671858 16 0 15.3281 0 14.5V3.5C0 2.67186 0.671858 2 1.5 2H6.5C6.77614 2 7 2.22386 7 2.5C7 2.77614 6.77614 3 6.5 3H1.5C1.22414 3 1 3.22414 1 3.5V14.5C1 14.7759 1.22414 15 1.5 15H12.5C12.7759 15 13 14.7759 13 14.5Z",
    fill: "#051C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c1648d0b5b8d23fbdd85f8d3903dccea.svg";
export { ForwardRef as ReactComponent };